<template>
    <div class="input-field" :class="displayClass">
        <div class="field-container w-full">
            <input 
                :type="inputType" 
                :id="name" 
                :value="modelValue"
                :placeholder="placeholder"
                @input="updateValue($event.target.value)"
            />
            <div v-if="icon" class="field-icon" @click="openSelect">
                <i :class="'icon-'+icon"></i>
            </div>
        </div>     
        <div class="invalid-feedback" v-if="errors" v-text="errors"></div>
    </div>
</template>

<script>
    export default {
        props: [
            'name',
            'placeholder',
            'type',
            'displayClass',
            'modelValue',
            'errors',
            'icon'
        ],

        emits: [
            'update:modelValue'
        ],

        computed: {
            inputType: function() {
                if (this.type) {
                    return this.type
                }
                return 'text'
            }
        },

        methods: {
            updateValue: function(value) {
                this.$emit('update:modelValue', value)
            },
        }
    }
</script>